import React from 'react';
import {
    //AutocompleteInput,
    BooleanField,
    BooleanInput,
    Datagrid,
    DateField,
    EditButton,
    FunctionField,
    List,
    ReferenceField,
    //ReferenceInput,
    //ReferenceArrayInput,
    //SelectArrayInput,
    //ShowButton,
    TextField,
    TextInput,
    DateInput
} from 'react-admin';
import {
    Filter,
} from 'ra-ui-materialui';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

const PostFilter = (props) => (
    <Filter {...props}>
        <TextInput label="User" source="user_username" alwaysOn />
        <TextInput label="Message" source="message" alwaysOn />
        <BooleanInput label="Is Approved?" source="approvednull" />
        <BooleanInput label="Is Deleted?" source="postdeleted" />
        <BooleanInput label="Needs Review?" source="needsReview" />
        <BooleanInput label="Is Spam?" source="spam" />
        <BooleanInput label="Has Links?" source="links" />
        <BooleanInput label="Has Profanity?" source="profanity" />
        <DateInput label="Updated" source="updated_at" />
    </Filter>
);

const postRowStyle = (record, index) => ({
    backgroundColor: record.needs_review === true ? '#ffc107' : 'white',
});

export const PostList = (props) => (
    <List {...props} filters={<PostFilter />} sort={{ field: 'createdAt', order: 'DESC' }} bulkActionButtons={false}>
        <Datagrid rowStyle={postRowStyle}>
            <ReferenceField label="User" source="user" reference="users">
                <TextField source="username" />
            </ReferenceField>
            <FunctionField label="Message" render={record => `${(record.message.length > 200 ? record.message.substring(0,200) + ' ...' : record.message).replace(/<.[^>]*>/g, '')}`} />
            <FunctionField label="Approved?"
                render={record => {
                    return (record.approved_at == null ? <CloseIcon/> : <CheckIcon/>)}
                } />
            <BooleanField label="Needs Review?" source="needs_review" sortBy="needsReview" />
            {/*
            <BooleanField label="Spam?" source="spam" sortBy="spam" />
            <BooleanField label="Links?" source="links" sortBy="hasLinks" />
            <BooleanField label="Profanity?" source="profanity" sortBy="hasProfanity" />
            */}
            {/*
            <ReferenceField label="Thread" reference="threads" source="thread">
                <TextField source="title" />
            </ReferenceField>
            <ReferenceField label="Parent" reference="posts" source="parent" allowEmpty>
                <TextField source="id" />
            </ReferenceField>
            */}
            <DateField disabled label="Updated" source="updated_at" showTime sortBy="updatedAt" />
            <DateField disabled label="Created" source="created_at" showTime sortBy="createdAt" />
            <EditButton />
        </Datagrid>
    </List>
);
